import {
  ActionDotsIcons,
  DeleteIcon,
  EditIcon,
} from "../../assets/icons/iconsProvider";
import {
  buttonNameConstants,
  buttonTypeConstants,
  EMPTY_STRING,
  globalConstants,
  SET_BY_MARGIN_OPTIONS,
  SET_BY_TRADE_IN_MARGIN_OPTIONS,
  STORE_BILLING_STATUS,
} from "../../constants";
import { Button, CustomTooltip, TableCustomCellWrapper } from "../components";
import TableCustomAppliesToField from "../components/table/TableCustomAppliesToField";
import { getActionColumnOfReactDataTableComponent } from "./columnHeadersUtility";
import { editDeleteActions } from "./genericUtility";

const isStripeSubscriptionActive = (billing) => {
  const storeBilling = billing?.billing || billing || {};
  return (
    storeBilling.storeBillingStatus === STORE_BILLING_STATUS.ACTIVE_SUBSCRIPTION
  );
};

const getAllStoreIds = (companyStores = []) => {
  return companyStores?.map((store) => store.id).join(",") || EMPTY_STRING;
};

const createCompanyStoreOptions = (
  companyStores,
  showAllStoresOption = true
) => {
  const storeOptions = companyStores.map((store) => ({
    label: store.storeName,
    value: store.id,
  }));
  return [
    showAllStoresOption &&
      companyStores.length > 1 && {
        label: globalConstants.ALL_STORES,
        value: getAllStoreIds(companyStores),
      },
    ...storeOptions,
  ].filter(Boolean);
};

const getCustomTaxRulesColumn = (props) => {
  const { handleEditClick, handleDeleteClick } = props;
  return [
    {
      id: "setBy",
      name: "Set By",
      selector: (row) => row.taxType,
      cell: (row) => {
        return (
          <TableCustomCellWrapper
            cellValue={
              SET_BY_TRADE_IN_MARGIN_OPTIONS.find(
                (item) => item.value === row.taxType
              ).label
            }
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "appliesTo",
      name: "Applies To",
      selector: (row) => row.taxGroup,
      cell: (row) => {
        return (
          <TableCustomAppliesToField
            row={row}
            groupArray={row.taxGroup}
            groupType={row.taxType}
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "saleTaxRate",
      name: "Sale Tax Rate",
      selector: (row) => row.saleTaxRate,
      cell: (row) => (
        <TableCustomCellWrapper cellValue={`${row.saleTaxRate}%`} />
      ),
      sortable: true,
      sortDirection: null,
    },
    editDeleteActions(handleEditClick, handleDeleteClick),
  ];
};
export {
  isStripeSubscriptionActive,
  createCompanyStoreOptions,
  getAllStoreIds,
  getCustomTaxRulesColumn,
};
